module.exports = __webpack_public_path__ + "images/emoji/partly_sunny.23e2679c191cbb4d4dee.png";